import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { SdHtmlComponent, SdTitleComponent } from '@seb/web-design-system/core';

import { CmsTabParagraphComponentInterface } from '../../../models';
import { AbstractComponent } from '../abstract-component.component';

@Component({
  selector: 'wc-cms-tab-paragraph',
  templateUrl: './cms-tab-paragraph.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdTitleComponent,
    SdHtmlComponent
  ]
})
export class CmsTabParagraphComponent extends AbstractComponent<CmsTabParagraphComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  title = '';
  content = '';
  name = '';

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$.subscribe((cmp: CmsTabParagraphComponentInterface) => {
        this.title = cmp.title;
        this.name = cmp.name;
        this.content = cmp.content;
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }
}
